
import React from 'react';
import { Row, Button, Title, SelectedHardwareResume } from './ColapseConfig.style';


export interface ColapseConfigProps {
    memory: string;
    internet: string;
    size: string;
    function: () => void;
    isShown: boolean;
    children?: React.ReactNode;
};


export const UHCColapseConfig: React.FC<ColapseConfigProps> = (props: ColapseConfigProps) => {

    return (
        <>
            <Row>
                <Title >Configuração Atual</Title>
                <SelectedHardwareResume>{props.memory} - {props.internet} - {props.size}</SelectedHardwareResume>
                <Button
                    data-testid='colapse-button'
                    onClick={props.function}
                    aria-controls="advancedSettings"
                    aria-expanded={!props.isShown}
                >
                    Alterar Configurações
                </Button>
            </Row>
            {props.isShown ? props.children : null}

        </>
    )
}

